export const component = {
    AssetList:1,
    AssetDetailsWidget:2,
    InvestorList:3,
    InvestmentDocumentList:4,
    InvestmentRuleList:1002,
    ClientRuleList:1003,
    DeletionRuleList:1004,
    ReturnsStatisticsSummaryWidget:1005,
    UserPreferenceIds:1006,
    TransactionList:1007,
    AssetListFilters:1008,
    UniverseList:1009,
    ThemesGrid:1011,
    ThemeList:1012
}